const SOUND_KEY = "hl_scan_sound";
let ctx = null;

export const soundEnabled = () => localStorage.getItem(SOUND_KEY) !== "off";
export const setSoundEnabled = (on) => localStorage.setItem(SOUND_KEY, on ? "on" : "off");

/** Beep pendek via Web Audio (tanpa file audio). kind: "ok" | "error" */
export function beep(kind = "ok") {
  if (!soundEnabled()) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = ctx || new AC();
    if (ctx.state === "suspended") ctx.resume();
    const tones = kind === "error" ? [[320, 0, 0.18]] : [[1320, 0, 0.09], [1760, 0.1, 0.1]];
    tones.forEach(([freq, delay, dur]) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "square";
      osc.frequency.value = freq;
      const t0 = ctx.currentTime + delay;
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.25, t0 + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t0);
      osc.stop(t0 + dur + 0.02);
    });
  } catch (_) { /* audio tidak tersedia */ }
  if (navigator.vibrate) navigator.vibrate(kind === "error" ? [80, 40, 80] : 60);
}

/** Error jaringan (offline / server tidak terjangkau) → kandidat antrean offline */
export const isNetworkError = (e) => !e?.response && (e?.code === "ERR_NETWORK" || e?.message === "Network Error" || !navigator.onLine);
